<template>
  <div class="order-list">
    <div class="order-item" v-for="(item, i) of list" :key="i">
      <div class="top">
        <div class="left">
          <div class="source">{{ item.orderSourceName }}</div>
          <div class="booker">{{ item.bookerName }}</div>
          <div class="phone">{{ item.bookerPhone }}</div>
        </div>
        <div class="right">
          <div class="detail" @click="toDetail(item)">详情</div>
        </div>
      </div>
      <div class="body">
        <div class="body-top">
          <div class="room-name">
            {{ item.roomName }}({{ item.orderTypeName }})
          </div>
          <div class="room-status">
            {{
              {
                1: "已预订",
                2: "已登记",
                3: "已入住",
                4: "已完成",
                5: "已取消",
                6: "已失效",
              }[item.orderState]
            }}
          </div>
        </div>
        <div class="body-bottom">
          <div class="left">
            <div class="time">
              {{ item.actualCheckInTime || item.proposedCheckInTime }} - {{ item.actualCheckOutTime || item.proposedCheckOutTime }}
            </div>
            <div class="time-length">{{ getDiffTimeStr(item) }}</div>
            <div class="person-count">{{ item.personCount }}人</div>
          </div>
          <div class="right">
            <div class="price">
              <span style="color: red; font-weight: 600">￥</span
              >{{ item.orderPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/views/baseInfo/order/mixin.js";
export default {
  name: "OrderList",
  mixins: [mixin],
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail(item) {
      this.$emit("toDetail", item.id);
    },
    //相差几晚,1-全日房，2-钟点房
    getDiffTimeStr(row) {
      let start =
        row.orderState == 3 || row.orderState == 4
          ? row.actualCheckInTime
          : row.proposedCheckInTime;
      let end =
        row.orderState == 4 ? row.actualCheckOutTime : row.proposedCheckOutTime;
      let timeStr = this.getDiffTime(start, end, row.orderType);
      return timeStr + (row.orderType == 2 ? "小时" : "晚");
    },
  },
};
</script>

<style lang="less" scoped>
.order-list {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow: auto;
  .order-item {
    border: 1px solid gray;
    margin-bottom: 8px;
    .top {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid gray;
      padding: 8px;
      .left {
        display: flex;
        .source {
          color: orange;
          margin-right: 8px;
        }
        .booker {
          margin-right: 8px;
        }
        .phone {
        }
      }
      .right {
        .detail {
          color: blue;
          cursor: pointer;
        }
      }
    }
    .body {
      padding: 8px;
      .body-top {
        display: flex;
        justify-content: space-between;
        .room-name {
          font-weight: 600;
        }
        .room-status {
        }
      }
      .body-bottom {
        display: flex;
        justify-content: space-between;
        .left {
          display: flex;
          .time {
            margin-right: 8px;
          }
          .time-length {
            margin-right: 8px;
          }
          .person-count {
            border-left: 1px solid gray;
            padding-left: 8px;
          }
        }
        .right {
          .price {
          }
        }
      }
    }
  }
}
</style>